import { BaseBackend } from "@jupiter/core";
import { BrowserOptions } from "./types/options";
import { Transport } from "@jupiter/types";
import { XHRTransport } from "./transports";
export class BrowserBackend extends BaseBackend<BrowserOptions> {
  /**
   * @inheritDoc
   */
  protected _setupTransport(): Transport {
    if (!this._options.endpoint) {
      return super._setupTransport();
    }

    const transportOptions = {
      endpoint: this._options.endpoint,
    };

    return new XHRTransport(transportOptions);
  }
}
